export const MONTHS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const WEEKDAYS = ["Lu", "Ma", "Mi", "Ju", "Vi", "Sá", "Do"];

export const SHIP_TYPES = [
  {
    id: "1",
    name: "AGAVERO 46 FT",
    img: "/img/3b2518e3505ada61ac8ba4895c40f99c.png",
  },
  {
    id: "2",
    name: "DJACKIE 48 FT",
    img: "/img/b2609fba789301df97823b65d458f105.png",
  },
  {
    id: "3",
    name: "SIN NOMBRE 55 FT",
    img: "/img/cb1f10a2af2768f8b825d727ea50d1d9.png",
  },
];
